import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'What can I do with the Free Plan?',
      answer: 'The Free Plan gives you access to Agents 1-3, allowing you to research book topics, capture your writing voice, and create detailed outlines. This is perfect for planning your book and getting started. However, to access AI-powered manuscript writing (Agents 4-11), you\'ll need to upgrade to a paid plan.'
    },
    {
      question: 'When do I need to upgrade from the Free Plan?',
      answer: 'You need to upgrade when you\'re ready to start writing your book with AI assistance. The Free Plan covers all the research and planning phases, but paid plans unlock the complete AI writing workflow, cover design, formatting, and KDP metadata generation.'
    },
    {
      question: 'Can I switch plans later?',
      answer: 'Yes! You can upgrade or downgrade your plan at any time. When upgrading, you\'ll get immediate access to additional features. When downgrading, the change will take effect at the start of your next billing cycle.'
    },
    {
      question: 'What happens if I exceed my monthly book limit?',
      answer: 'If you reach your monthly book limit, you can either wait for the next billing cycle or upgrade to a higher tier immediately to continue creating books. All your existing projects remain accessible regardless of your plan.'
    },
    {
      question: 'Do all plans include community access?',
      answer: 'The Free Plan does not include community access. All paid plans (Starter, Professional, Business, and Enterprise) include automatic access to the Authorpreneur Community on Skool, where you can connect with other authors and publishing experts.'
    },
    {
      question: 'What\'s included in the 11 AI agents?',
      answer: 'The 11 AI agents guide you through the complete book creation process: title research (Agent 1), voice capture (Agent 2), outline creation (Agent 3), and manuscript writing through KDP metadata generation (Agents 4-11). Free Plan includes Agents 1-3, while paid plans include all 11 agents.'
    }
  ];

  return (
    <div className="max-w-4xl mx-auto">
      <div className="text-center mb-12">
        <h2 className="text-3xl lg:text-4xl font-heading font-bold text-foreground mb-4">
          Frequently Asked Questions
        </h2>
        <p className="text-lg text-muted-foreground">
          Everything you need to know about our pricing and plans
        </p>
      </div>

      <div className="space-y-4">
        {faqs?.map((faq, index) => (
          <div
            key={index}
            className="bg-card border border-border rounded-xl overflow-hidden transition-all duration-200"
          >
            <button
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
              className="w-full px-6 py-5 flex items-center justify-between hover:bg-muted/50 transition-colors"
            >
              <span className="text-left text-foreground font-medium pr-4">
                {faq?.question}
              </span>
              <Icon
                name={openIndex === index ? 'ChevronUp' : 'ChevronDown'}
                size={20}
                color="var(--color-muted-foreground)"
                className="flex-shrink-0"
              />
            </button>

            {openIndex === index && (
              <div className="px-6 pb-5 pt-0">
                <p className="text-muted-foreground leading-relaxed">
                  {faq?.answer}
                </p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQSection;